<template>
    <template v-if="hasChildren(menu)">
        <v-list-group :value="menu.menu_name">
            <template #activator>
                <v-list-item @click="toggleMenu(menu)">
                    <div class="menu-item">
                        <span class="menu-text font-weight-bold">{{ menu.menu_name }}</span>
                        <v-icon class="ml-auto">
                            {{ open?.includes(menu.menu_name) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                        </v-icon>
                    </div>
                </v-list-item>
            </template>
            <navbar-menuItem v-for="(child) in menu.children_menu_list" :menu="child" :currentMenuId/>
        </v-list-group>
    </template>
    <template v-else>
        <v-list-item :to="menu.menu_url" link>
            <div class="menu-item d-flex">
                <span class="menu-text">{{ menu.menu_name }}</span>
                <span class="badge ml-2" v-if="menu.menu_id=='PROP004' && notificationStore.notification > 0"> {{ notificationStore.notification }}</span>
            </div>
        </v-list-item>
    </template>
</template>

<script setup lang="ts">
import { useNotificationStore } from '@/stores/notification';
import { API_PROPERTY_MANAGER_000 } from "~/constants/property_manager/api-property-manager-000";
import type { Prop000001Response} from "@/types/property-manager/prop-000";
const notificationStore = useNotificationStore();
const open = defineModel<any[]>();
const props = defineProps<{
    menu: any,
    currentMenuId: any
}>()
const response1: Ref<Prop000001Response | undefined> = ref();
const toggleMenu = async (menu: any) => {
  if (open.value) {
    localStorage.setItem('click_url', '0');
    if (open.value.includes(menu.menu_name)) {
        open.value = open.value.filter(item => item != menu.menu_name)
        localStorage.setItem('opening_menu', open.value.filter(item => item != menu.menu_name).toString());
    } else {
        open.value?.push(menu.menu_name)
        if (menu.menu_name === 'TOP') {
          response1.value = (await useApi.post<any>(API_PROPERTY_MANAGER_000.PROP_API_000_001, {}, {})).response_data;
          notificationStore.setter(response1.value?.count_notification ?? 0)
        }
        localStorage.setItem('opening_menu', open.value.toString());
    }
    
  }
}

const hasChildren = (item: any) => item.children_menu_list && item.children_menu_list.length > 0
</script>
<style scoped>
.custom-navbar {
  background-color: #f8f9fa;
}

.menu-item {
  display: flex;
  align-items: center;
}

.menu-icon {
  font-size: 18px;
  margin-right: 8px;
  color: #333;
}

.menu-text {
  font-size: 15px;
}

.custom-sub-item {
  padding-left: 50px;
  font-size: 14px;
  display: flex;
  align-items: center;
}
::v-deep(.v-list-item:hover) {
  background-color: #D2F4EA !important;
}
::v-deep(.v-list-item__append) {
  display: none !important;
}
.badge {
  background-color: red;
  color: white;
  padding: 2px 6px;
  font-size: 12px;
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  line-height: 16px;
  text-align: center;
  font-weight: bold;
  box-shadow: 0 0 0 1px white;
}
</style>